export default function parseQueryParams(data) {
  if (!data) {
    return '';
  }

  return Object.entries(data)
    .map(([key, value]) => {
      const joined = Array.isArray(value) ? value.join(',') : value;
      const encoded = encodeURIComponent(joined).replace(/%2C/g, ',');
      return `${key}=${encoded}`;
    })
    .join('&');
}
